import React, { useCallback, useState } from 'react';
// @ts-ignore
import Highlighter from 'react-highlight-words';
import cn from 'classnames';
import dayjs from 'dayjs';
// @ts-ignore
import { humanFileSize } from 'utils/commonFunc';
// @ts-ignore
import { DownloadIcon, CloseIcon } from 'theme/icon';
// @ts-ignore
import ExtIcon from '../../control/extension.tsx';
// @ts-ignore
import Modal from '../../control/modal/modal.tsx';
// @ts-ignore
import { IViewProps, IDocument } from '../grid/index.tsx';
// @ts-ignore
import { useHref, useExtension } from '../hooks.tsx';

import styles from './styles.scss';

const TableView: React.FC<IDocument & IViewProps> = ({
  extension,
  name,
  insertDate,
  progress = 100,
  isEditAccess = false,
  deleteDocument,
  documentId,
  hash,
  isPro = false,
  bucket,
  link = '#',
  tag,
  size,
  highlighter,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = useCallback(() => setModalOpen(open => !open), [setModalOpen]);

  const href = useHref({ isPro, bucket, hash, name, extension, link, progress });
  const ext = useExtension({ name, extension });
  return (
    <div
      className={progress === 100 ? cn(styles.document, styles.active) : styles.document}
      onClick={event => event.stopPropagation()}
    >
      <ExtIcon size={40} extension={ext} />
      <div className={styles.name_wrapper}>
        <div className={styles.name} title={name}>
          <Highlighter
            highlightStyle={{
              backgroundColor: '#fcefd3',
              padding: 0,
            }}
            searchWords={[highlighter]}
            autoEscape
            textToHighlight={name}
          />
        </div>
      </div>
      <div className={styles.dateTime_wrapper}>
        {insertDate && <div className={styles.dateTime}>{dayjs(insertDate).format('D.M.YYYY')}</div>}
      </div>
      <div className={styles.size_wrapper}>
        {size && <span className={styles.size}>{humanFileSize(Number(size))}</span>}
      </div>
      <div className={styles.tag_wrapper}>{tag && <div className={styles.tag}>{tag}</div>}</div>
      {progress === 100 && documentId !== -1 && (
        <React.Fragment>
          <div className={styles.actions_wrapper}>
            {href && (
              <a className={styles.action} href={href} title="Скачать" download>
                <DownloadIcon />
              </a>
            )}
            {isEditAccess && (
              <div className={cn(styles.action, styles.delete)} title="Удалить" onClick={toggleModal}>
                <CloseIcon />
              </div>
            )}
          </div>
        </React.Fragment>
      )}
      {(progress < 100 || documentId === -1) && (
        <div className={styles.progressBar}>
          {progress >= 0 && (
            <div className={styles.background}>
              <div className={styles.percent} style={{ width: 7 * progress }} />
            </div>
          )}
          {progress === -1 && <div className={styles.error}>Не загрузилось</div>}
        </div>
      )}
      <Modal
        modalOpen={modalOpen}
        extension={extension}
        name={name}
        deleteDocument={deleteDocument}
        documentId={documentId}
        toggleModal={toggleModal}
      />
    </div>
  );
};

export default TableView;
